import fetch from "cross-fetch";
import { Helper } from "../helpers/helper";

let idmsBaseUrl = "https://iimport-ca.cloud.csiinc.com/task";

async function executeIdmsTask(executionId: string, payload = {}, isPolling = true) {
    const url: string = isPolling ? `${idmsBaseUrl}/executepolling/${executionId}` : `${idmsBaseUrl}/execute/${executionId}`;
    let executionResponse = await fetch(url, { method: "POST", body: JSON.stringify(payload), headers: { "Content-Type": "application/json" } });
    let executionResponseData = await executionResponse.text();
    if (!executionResponse.ok) {
        throw new Error(`Failed to execute IDMS task. Status: ${executionResponse.status}, Message: ${JSON.stringify(executionResponseData)}`);
    }

    let isPollingStatusCode = () => {
        return executionResponse.status == 202;
    };
    let delayTask = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));
    if (isPolling && isPollingStatusCode()) {
        // get the location url from the response headers
        const pollingUrl = executionResponse.headers.get("Location");
        const pollingRetryAfter = Number.parseInt(executionResponse.headers.get("Retry-After") || "30");
        if (Helper.isStringNullOrEmpty(pollingUrl)) {
            throw new Error("Polling URL not found in the response headers.");
        }

        do {
            await delayTask(pollingRetryAfter * 1000);
            executionResponse = await fetch(pollingUrl, { method: "GET", headers: { "Content-Type": "application/json" } });
            executionResponseData = await executionResponse.text();
            if (!executionResponse.ok) {
                throw new Error(`Failed to poll IDMS task. Status: ${executionResponse.status}, Message: ${JSON.stringify(executionResponseData)}`);
            }
        } while (isPollingStatusCode());
    }

    return executionResponse.status == 200 ? JSON.parse(executionResponseData) : executionResponseData;
}

export {
    idmsBaseUrl,
    executeIdmsTask,
};
